import {
  createContext,
  useContext,
  ReactNode,
  Context,
  useState,
} from "react";
import { BusinessLocation } from "../../../types/business_location";

type BusinessLocationType = {
  businessLocation: BusinessLocation | null;
  businessLocations: BusinessLocation[];
  updateBusinessLocation: (id: string) => void;
};

const BusinessLocationContext: Context<BusinessLocationType | undefined> =
  createContext<BusinessLocationType | undefined>(undefined);

export const useBusinessLocation = (): BusinessLocationType => {
  const context = useContext(BusinessLocationContext);
  if (!context) {
    throw new Error(
      "useBusinessLocation must be used within a BusinessLocationProvider"
    );
  }
  return context;
};

interface BusinessLocationProviderProps {
  children: ReactNode;
}

export const BusinessLocationProvider = ({
  children,
}: BusinessLocationProviderProps) => {
  const [businessLocation, setBusinessLocation] =
    useState<BusinessLocation | null>(null);

  const updateBusinessLocation = (_value: string) => {
    setBusinessLocation(null);
  };

  return (
    <BusinessLocationContext.Provider
      value={{
        businessLocation,
        businessLocations: [],
        updateBusinessLocation,
      }}
    >
      {children}
    </BusinessLocationContext.Provider>
  );
};
